import { Component, Inject, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { InstallerPassModel } from '@bo-client/shared/models/installerPassDto';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserDto } from '@bo-client/shared/models/userDto';

@Component({
  selector: 'app-tm-user-list-modal',
  templateUrl: './tm-user-list-modal.component.html',
  styleUrls: ['./tm-user-list-modal.component.scss']
})
export class TmUserListModalComponent implements OnInit {
  public displayedColumns: string[] = ['user', 'action'];
  public dataSourceList = new MatTableDataSource<InstallerPassModel>([]);

  constructor(
    public dialogRef: MatDialogRef<TmUserListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: any
  ) {}

  ngOnInit(): void {
    this.dataSourceList = this.inputData.tmUserList;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  newCommissioningWithoutPass(user: UserDto) {
    this.dialogRef.close({ user: user });
  }
}
